define((require) => {
    "use strict";

    const AnimationPropertiesView       = require("ui/experience/widgets/animations/AnimationPropertiesView");
    const {STYLES}                      = require("shared/xp/components/widgets/socialsharing/SocialSharingService");
    const SizeAndPositionPropertiesView = require("ui/experience/widgets/SizeAndPositionPropertiesView");
    const template                      = require("ui/experience/widgets/socialSharingWidget/SocialSharingWidgetPropertiesView.tpl");
    const AbstractWidgetPropertiesView  = require("ui/experience/widgets/AbstractWidgetPropertiesView");

    const EXPAND_PROPERTY = "socialSharingWidgetExpanded";

    /**
     * @class SocialSharingWidgetPropertiesView
     * @constructor
     *
     * @cfg {SocialSharingWidgetModel}
     */
    return AbstractWidgetPropertiesView.extend({

        expandProperty: EXPAND_PROPERTY,

        className: "social-sharing-widget-properties-view",

        template,

        templateHelpers() {
            return {
                styles: STYLES
            };
        },

        ui: {
            container: ".social-sharing-widget-properties",
            legend: "[data-target=\".social-sharing-widget-properties\"]",
            optionsContainer: ".options"
        },

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            actionProperties: ".action-properties",
            animationProperties: ".animation-properties",
            networkSettingsProperties: ".network-settings-properties"
        },

        bindings: {
            ".share-url": "url"
        },

        events: {
            "click .options a": "_selectStyleHandler"
        },

        modelEvents: {
            "change:style": "_updateToCurrentStyle"
        },

        _selectStyleHandler(event) {
            event.preventDefault();

            // Parse the selected style
            const style = event.currentTarget.getAttribute("data-style");

            // Update the model
            this.model.set("style", style);
        },

        /**
         * Updates the UI by reflecting the current selected theme.
         */
        _updateToCurrentStyle() {
            const {optionsContainer} = this.ui;
            // Reset 'selected' state
            optionsContainer.find("a").removeClass("selected");
            optionsContainer.find("a .style-sharing-container :first-child").removeClass("active");

            const selectedTarget = optionsContainer.find("[data-style='" + this.model.get("style") + "']");
            selectedTarget.addClass("selected");
            selectedTarget.find(".style-sharing-container :first-child").addClass("active");
        },

        onRender() {
            this.__super();
            const hasGoogleplusNetwork = this.model.get("networks").some((network) => network === "googleplus");
            if (hasGoogleplusNetwork) {
                this.ui.optionsContainer.find(".category").addClass("has-googleplus");
            }
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                hideSizeControls: true,
                hideRotation: true,
                widgetView: this.options.widgetView
            }));
            this.animationProperties.show(new AnimationPropertiesView({model: this.model, widgetView: this.options.widgetView}));
            this._updateToCurrentStyle();
        }
    }, {
        EXPAND_PROPERTY
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/socialSharingWidget/SocialSharingWidgetPropertiesView.js